import Swiper, {
  FreeMode, Keyboard, Mousewheel, Navigation,
} from 'swiper';

import throttle from '../utils/throttle';
import { breakpoints } from '../config/breakpoints';

class RoomSwiper {
  constructor() {
    this.swiperContainerClass = '.room__swiper';
    this.roomPreviewContainerClass = 'room__preview-link';
    this.roomDialogButton = 'room-dialog__button';
    this.swiperContainer = this.getSwiperContainer();
  }

  listeners = () => {
    window.addEventListener('DOMContentLoaded', this.initSlider);
    window.addEventListener('resize', throttle(this.resize));
    window.addEventListener('click', this.toggleGallery);
    window.addEventListener('keyup', this.toggleGalleryByKey);
  };

  resize = () => {
    if (window.innerWidth > breakpoints.lg) {
      this.swiperContainer.classList.remove('room__swiper--show');
      document.querySelector('body').classList.remove('room--active-popup');
    }
  };

  toggleGallery = (event) => {
    const element = event.target;
    const elementClassList = element.classList;

    if (!element || !elementClassList) {
      return;
    }

    const dialog = document.querySelector(this.swiperContainerClass);

    if (elementClassList.contains(this.roomPreviewContainerClass)) {
      dialog.showModal();
      document.querySelector('body').classList.add('room--active-popup', 'overflow-hidden');
      document.querySelector(`.${this.roomDialogButton}`).removeAttribute('disabled');
      document.querySelector(`.${this.roomDialogButton}`).focus();
      this.swiperContainer.classList.add('room__swiper--show');
      this.initSlider(this.swiperContainerClass);
    } else if (elementClassList.contains(this.roomDialogButton)
      || element.parentNode.classList.contains(this.roomDialogButton)) {
      dialog.close();
      document.querySelector('body').classList.remove('room--active-popup', 'overflow-hidden');
      document.querySelector(`.${this.roomDialogButton}`).setAttribute('disabled', true);
      this.swiperContainer.classList.remove('room__swiper--show');
    }

    if (event.type === 'click' || window.innerWidth < breakpoints.lg) {
      document.querySelector(`button.${this.roomDialogButton}:not([disabled])`).classList.toggle('focus-disabled');
    }
  };

  toggleGalleryByKey = (event) => {
    if (window.innerWidth < breakpoints.lg) {
      const { keyCode } = event;

      if (keyCode === 32 || keyCode === 13) {
        if (event.target) {
          this.toggleGallery(event.target);
        }
      }
    }
  };

  getSwiperContainer = () => document.querySelector(this.swiperContainerClass);

  initSlider = () => {
    // eslint-disable-next-line no-new
    new Swiper(this.swiperContainerClass, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      modules: [Keyboard, Navigation, Mousewheel, FreeMode],
      freeMode: true,
      grabCursor: true,
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        invert: false,
      },
      breakpoints: {
        0: {
          freeMode: false,
          grabCursor: false,
          noSwiping: true,
          direction: 'horizontal',
        },
        992: {
          noSwiping: false,
          direction: 'vertical',
        },
      },
      navigation: {
        nextEl: '.room__button--next',
        prevEl: '.room__button--prev',
        disabledClass: 'c-arrow--disabled',
      },
    });
  };
}

const roomSwiperObject = new RoomSwiper();
roomSwiperObject.listeners();
